export const DEFAULT_BUTTON_BACKGROUND = "linear(to-r, red.400,pink.400)"
export const DEFAULT_BUTTON_HOVER = "linear(to-r, red.400,pink.400)"